export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/5bdee9c7320d1c56bdb17af44609f5ad.jpg"
          alt="Professional Property Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="max-w-3xl">
          <div className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
            Professional Property Services
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Your Property's<br />
            Best Friend<br />
            For Every Season
          </h1>
          
          <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-2xl">
            From pools to gutters, pressure washing to junk removal - we handle it all so you don't have to
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => scrollToSection('services')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              View Our Services
            </button>
            <a 
              href="tel:+16262447341"
              className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Call or Text
            </a>
          </div>

          <div className="mt-12 bg-white/95 backdrop-blur-sm rounded-xl p-6 inline-block shadow-xl">
            <div className="flex flex-wrap gap-6 text-gray-900">
              <div className="flex items-center space-x-2">
                <i className="ri-checkbox-circle-fill text-orange-500 text-xl"></i>
                <span className="font-medium">12+ Services</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-fill text-orange-500 text-xl"></i>
                <span className="font-medium">Licensed &amp; Insured</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-fill text-orange-500 text-xl"></i>
                <span className="font-medium">Same-Day Available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}